<template>
  <Homepage></Homepage>
</template>

<script>
import Homepage from "./components/Homepage.vue";

export default {
  name: "App",
  components: {
    Homepage
  }
};
</script>

<style>
html,
body {
  margin: 0;
  padding: 0;
}

#app {
  min-height: 100vh;
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>
